import { ExpenseReportParams } from 'config/requests/expenseReport';
import { getUnixTime } from 'date-fns';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';

import { ExpenseReportFilterFormValues } from '../ExpenseReportListFilter/ExpenseReportListFilter';

export function mapFiltersToParams(
  filters: ExpenseReportFilterFormValues,
): Partial<ExpenseReportParams> {
  if (!filters.appliedDate[0] || !filters.appliedDate[1] || !filters.currency) {
    return {};
  }

  return {
    dateFrom: getUnixTime(filters.appliedDate[0] as number),
    dateTo: getUnixTime(filters.appliedDate[1] as number),
    currency: filters.currency,
    referral: filters.referral?.length ? filters.referral : undefined,
    expenseTypes: filters.expenseTypes?.length ? filters.expenseTypes : undefined,
    expenseArticles: filters.expenseArticles?.length ? filters.expenseArticles : undefined,
    expenseSubarticles: filters.expenseSubarticles?.length ? filters.expenseSubarticles : undefined,
    timezone: filters.timezone || DEFAULT_TIMEZONE,
  };
}
